// 3rd-party modules
import { Badge, Tooltip } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

// project modules
import Button from '../shared/button';
import { apiCall } from '../../helpers/apiHelper';
import { SvgLoader } from '../svg';

// apis
import * as SupportTicketApi from '../../apis/supportTicketApi';

// models
import { DataSourceRequest, FilterDescriptor, PaginationDescriptor, SortDescriptor } from '../../models/dataSourceRequest';
import { SupportTicket } from '../../models/supportTicket';

export default function HeaderNotifications() {
  const isFirstLaunch = useRef(true);
  const [loading, setLoading] = useState(false);
  const [openSupportTicketsCount, setOpenSupportTicketsCount] = useState(0);
  const location = useLocation();
  let abortController = new AbortController();

  useEffect(() => {
    getOpenSupportTicketsAsync(isFirstLaunch.current);

    if (isFirstLaunch.current) {
      isFirstLaunch.current = false; // Mark as launched
    }

    return () => { abortController.abort(); }
  },[location]);

  const getOpenSupportTicketsAsync = async (showLoader: boolean = true) => {
    // to avoid show loader on each page change
    if (showLoader) {
      setLoading(true);
    }

    const openSupportTickets = await getOpenSupportTicketsCount([{fieldName: "status", fieldValue: "Waiting For Client Response"}], undefined, undefined, abortController.signal);

    setOpenSupportTicketsCount((openSupportTickets?.length || 0));
    setLoading(false);
  };

  const getOpenSupportTicketsCount = async (conditionList?: FilterDescriptor[], sortList?: SortDescriptor[], pagination?: PaginationDescriptor, abortSignal?: AbortSignal) => {
    const request = { conditionList, sortList, pagination } as DataSourceRequest;
    const response = await apiCall(SupportTicketApi.getSupportTickets(request, abortSignal));

    return response.success ? SupportTicket.toArrayOfClass(response.data?.value || []) : [];
  };

  return (
    <>
      <Tooltip placement="bottom" title="Support tickets">
        {/* <group data-width="auto" data-name="autoseparation"> */}
        <Badge count={!loading ? openSupportTicketsCount : null}>
          { loading &&
            <icon><SvgLoader /></icon>
          }
          { !loading &&
            <Link to="/portal/support-tickets">
              <Button micro icon="notifications" />
            </Link>
          }
        </Badge>
        {/* </group> */}
      </Tooltip>
    </>
  );
}
